<template>
  <div class="usermanage-userpage padding-30">
    <div class="main-add">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
        <input type="password" style="display: none;" />
        <el-form-item label="账号：" prop="username">
          <el-input
            v-model="ruleForm.username"
            :disabled="isEdit"
            placeholder="输入长度大于5的不区分大小写英文或数字"
            autocomplete="off"
            type="text"
          />
        </el-form-item>
        <el-form-item label="密码：" prop="password" class="reset">
          <el-input
            id="iio"
            v-model="ruleForm.password"
            name="pwd"
            placeholder="8-16位的大小写英文、数字组合的密码"
            :type="isEdit?'password':'text'"
            autocomplete="new-password"
          />
          <el-button v-if="isEdit" type="text" @click="resetPwd">重置密码</el-button>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请填写姓名" />
        </el-form-item>

        <el-form-item label="项目：" prop="projectId" class="department" filterable>
          <el-select
            v-model="ruleForm.projectId"
            placeholder="项目名称搜索"
            filterable
            :disabled="isEdit"
            @change="hasSelectProject"
          >
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="FTP账号:" prop="ftpUser">
          <el-select
            v-model="ruleForm.ftpUser"
            placeholder="请选择FTP账号"
            filterable
            :disabled="isEdit"
          >
            <el-option
              v-for="(item,index) in ftpoptions"
              :key="index"
              :label="item.user"
              :value="item.user"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="启用：">
          <el-switch v-model="ruleForm.enable" />
        </el-form-item>
        <el-form-item>
          <el-button @click="goback">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="submitDisable">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { roleQuery } from "@/api/role";
import { mapGetters } from "vuex";
import {
  projectquery,
  getInfo,
  editAccount,
  addAccount,
  userslist
} from "@/api/user";
const defaultForm = {
  username: "",
  password: "abc12345",
  prePwd: "",
  email: "",
  name: "",
  projectId: "",
  projectName: "",
  enable: true,
  ftpUser: ""
};
export default {
  computed: {
    ...mapGetters(["username"])
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validateusername = (rule, value, callback) => {
      const bool = /^[0-9A-Za-z]{5,16}$/.test(value);
      if (value && value.trim()) {
        if (!bool) {
          callback(new Error("请输入长度5~16的英文字母或数字"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入账号"));
      }
    };
    var validatepassword = (rule, value, callback) => {
      const bool = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)[0-9A-Za-z]{8,16}$/.test(
        value
      );
      if (value === "" || !value.trim()) {
        callback(new Error("请输入密码"));
      } else {
        if (this.isEdit) {
          const bool2 = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)[0-9A-Za-z]{8,}$/.test(
            value
          );
          if (!bool2) {
            callback(new Error("请输入8-16位的大小写英文、数字组合的密码"));
          } else {
            callback();
          }
        } else {
          if (!bool) {
            callback(new Error("请输入8-16位的大小写英文、数字组合的密码"));
          } else {
            callback();
          }
        }
      }
    };
    var validateProject = (rule, value, callback) => {
      console.log("username", this.isEdit);
      if (this.isEdit) {
        callback();
      } else {
        if (!value) {
          callback(new Error("请选择项目"));
        } else {
          callback();
        }
      }
    };

    return {
      ruleForm: Object.assign({}, defaultForm),
      userId: "",
      submitDisable: false,
      options: [],
      ftpoptions: [],
      rules: {
        username: [
          { required: true, validator: validateusername, trigger: "blur" }
        ],
        password: [
          { required: true, validator: validatepassword, trigger: "blur" }
        ],
        ftpUser: [{ trigger: "change", message: "请选择FTP账号" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        projectId: [
          {
            required: true,
            validator: validateProject,
            // message: "请选择项目",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    projectquery().then(res => {
      this.options = res.data;
    });

    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id * 1;
      this.userId = id;
      this.fetchData(id);
    } else {
      this.ruleForm = Object.assign({}, defaultForm);
    }
  },
  methods: {
    resetPwd() {
      this.ruleForm.password = "abc12345";
    },
    fetchData(id) {
      getInfo(id).then(res => {
        const data = res.data.account;
        this.ruleForm = {
          username: data.username,
          password: data.password,
          email: data.email,
          name: data.name,
          projectId: data.projectId,
          enable: !!data.enable,
          ftpUser: data.ftpUser
        };
        this.prePwd = data.password;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = {
            username: this.ruleForm.username.trim(),
            password:
              this.ruleForm.password.trim() === this.prePwd
                ? null
                : this.ruleForm.password.trim(),
            name: this.ruleForm.name.trim(),
            projectId: this.ruleForm.projectId,
            enable: this.ruleForm.enable ? 1 : 0,
            ftpUser: this.ruleForm.ftpUser
          };

          if (this.isEdit) {
            data.id = this.userId;
            console.log("data", data);
            editAccount(data)
              .then(res => {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$router.push({ name: "account" });
              })
              .catch(err => {
                this.$message.error(err.message);
              });
          } else {
            addAccount(data)
              .then(res => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.$router.push({ name: "account" });
              })
              .catch(err => {
                this.$message.error(err.message);
              });
          }
        } else {
          return false;
        }
      });
    },
    hasSelectProject() {
      if (this.ruleForm.projectId) {
        userslist(this.ruleForm.projectId).then(res => {
          this.ftpoptions = res.data;
        });
      }
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" >
.usermanage-userpage {
  .main-add {
    background-color: #fff;
    border-radius: 4px;
    padding: 30px 20px;
    .el-form-item__content {
      width: 300px;
    }
    .reset {
      .el-form-item__content {
        width: 500px;
        .el-input {
          width: 300px;
        }
      }
    }
  }
  .department {
    .el-select {
      width: 100%;
    }
  }
}
</style>
